import { PaletteMode, createTheme } from '@mui/material';

const lightPalette = {
  primary: {
    light: '#4598CB',
    main: '#00639B',
    dark: '#0B233F',
    contrastText: '#F6F8F9',
  },
  secondary: {
    light: '#89C3E6',
    main: '#4598CB',
    dark: '#0B233F',
    contrastText: '#0B233F',
  },
  background: {
    // default: '#E2E5EA',
    default: '#F6F8F9',
    paper: '#FEFEFE'
  }
};

const darkPalette = {
  primary: {
    light: '#89C3E6',
    main: '#4598CB',
    dark: '#2487BA',
    contrastText: '#0B233F',
  },
  secondary: {
    light: '#4598CB',
    main: '#00639B',
    dark: '#0B233F',
    contrastText: '#89C3E6',
  },
  text: {
    primary: '#F6F8F9',
    secondary: '#E2E5EA',
    disabled: '#E2E5EA80'
  },
};

const defaultFonts = [
  'Roboto',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(',')
const fontHeadings = {
  fontFamily: 'Aldo, ' + defaultFonts,
	letterSpacing: '0.15em',
};
const fontBody = {
  fontFamily: defaultFonts,
  fontWeight: '300',
}

const getDesignTokens = (mode: PaletteMode) => ({
  palette: {
    mode,
    ...(mode === 'light' ? lightPalette : darkPalette),
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  typography: {
    fontFamily: defaultFonts,
    fontWeight: 'thin',
    h1: fontHeadings,
    h2: fontHeadings,
    h3: fontHeadings,
    h4: fontHeadings,
    h5: fontHeadings,
    h6: fontHeadings,
    button: fontHeadings,
    body1: fontBody,
    body2: fontBody,
  },
});

const darkTheme = createTheme(getDesignTokens("dark"))
const lightTheme = createTheme(getDesignTokens("light"))


export {darkTheme, lightTheme}